<template>
  <div class="list">
    <div class="item">
      <div class="view">
        <div class="canvasOuter">
          <canvas id="canvas1" class="canvas" width="160" height="160" />
        </div>
      </div>
    </div>
    <div class="item">
      <div class="view">
        <div class="canvasOuter">
          <canvas id="canvas2" class="canvas" width="160" height="160" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// https://codepen.io/493msi/pen/PZWLLv
import MaterialSpinner from '@/modules/day11-spinner.js'

export default {
  name: 'Day3',
  data: () => ({
    spinner1: false,
    spinner2: false
  }),
  methods: {
  },
  beforeDestroy() {
    if (this.spinner1) {
      this.spinner1.destroy()
    }
    if (this.spinner2) {
      this.spinner2.destroy()
    }
  },
  mounted() {
    this.spinner1 = new MaterialSpinner('canvas1', {
      color: '#111111'
    })
    this.spinner2 = new MaterialSpinner('canvas2', {
      color: '#dddddd'
    })
  }
}
</script>

<style scoped lang="scss">
.view {
  @include FR_FULLSIZE;
}
.canvasOuter {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.canvas {
  width: 80px;
  height: 80px;
  transform: translateZ(0);
}

/**
 * Custom
 */
.item {
  &:nth-child(2) {
    .spinner[data-spinner-color='white'] span {
      background-color: rgba(#ffffff, 0.5);
    }
  }
}
</style>
